<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/report/page/mes_basic_production_details"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('suoshuzuzhi')">
            <yi_data_select disabled :type="'organization'" :ids.sync="$attrs.details.orgId">
            </yi_data_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('banci')">
            <el-input disabled v-model="$attrs.details.shiftName"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinbianma/mingcheng')">
            <yi_cross_select disabled multiple :selectTitle="'code,name'"
                :component="'web_base_matter_list'" :ids.sync="$attrs.details.materialId">
            </yi_cross_select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('shengchangongdanhao')">
            <el-input disabled v-model="$attrs.details.woNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder"  :label="$t('riqi')">
            <el-input disabled v-model="$attrs.startThree"></el-input>
          </el-form-item>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form>
      </template>

      <template #shifoubulu="scope">
        {{scope.row.type == 0 ? $t('fou') : $t('shi')}}
      </template>
      <!-- 操作插槽 -->
    </yi_curd_table>
  </div>

</template>
<script type="text/javascript">
export default {

  name: 'web_report_producee_report_production/mes_tabs/product_details_three',
  data() {
    return {
      editConditions: {
        priority: ''
      },
      drawer: false,
      direction: 'btt',
      addDrawer: false,
      updateDrawer: false,
      graph: null,
      currentNode: null,
      selectParentIds: null,
      priority: null,
      routeList: [],
      nodeList: [],
      flows: [],
      currentNodeId: null,
      columns: [{
        label: 'shebeimingcheng',
        prop: 'equipmentName',
        width: 130
      }, {
        label: 'gongxumiaoshu',
        prop: 'procedureDesc',
        width: 130
      }, {
        label: 'baogongshuliang',
        prop: 'quantity',
        width: 130
      }, {
        label: 'buliangshuliang',
        prop: 'badQuantity',
      },
        {
          label: 'jiqijilushuliang',
          prop: 'machineQuantity',
          width: 150,
        },
        {
          label: 'chayishuliang',
          prop: 'diffQuantity',
          width: 150,
        },
        {
          label: 'tibaoshijian',
          prop: 'createTime',
          type: 'time',
          width: 150,
        }, {
          label: 'jiqijilukaishishijian',
          prop: 'startTime',
          type: 'time',
          width: 150,
        }, {
          label: 'jiqijilujieshushijian',
          prop: 'endTime',
          type: 'time',
          width: 150,
        }, {
          label: 'cavity',
          prop: 'cavity',
          width: 150,
        }, {
          label: 'standardCycle',
          prop: 'standardCycle',
          width: 150,
        }, {
          label: 'pingjunzhouqi(miao/mu)',
          prop: 'cycle',
          width: 150,
        }, {
          label: 'caozuoren',
          prop: 'operator',
          // width: 150,
        }, {
          label: 'shifoubulu',
          prop: 'type',
          type: 'slot'
          // width: 150,
        }, {
          label: 'beizhu',
          prop: 'remark',
        }
      ]
    };
  },
  mounted() {
    console.log('kkkkkkdddd', this.chart)
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        shiftId:this.$attrs.details.shiftId,
        orgId:this.$attrs.details.orgId,
        materialId:this.$attrs.details.materialId,
        woId:this.$attrs.details.woId,
        reportDateStr: this.$attrs.startThree,
      }
      this.yt.get(1)
    }, 300)
  },
  methods: {
    getNodeList() {
      this.http.get('/web/craft/basic/work/procedure/page', {
        params: {
          pageNum: 1,
          pageSize: 10
        }
      }).then(res => {
        this.nodeList = res.data.rows
        let workName = ''
        for (let i = 0; i < this.nodeList.length; i++) {
          this.nodeList[i].workName = this.nodeList[i]['code'] + '/' + this.nodeList[i]['desc']
        }
        console.log('lll', this.nodeList)
      })

    }
  }
};
</script>
